import {
  SET_SHOW_LOCALIZATION_SETTINGS,
  SET_LANGUAGE,
  SET_PREVIOUS_URL,
  SET_SAVED_LANGUAGE,
  SET_SELECTED_REGION,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_ERROR,
} from './actions';

const initialState = {
  showLocalizationSettings: false,
  language: 'English',
  url: 'en-us',
  previousUrl: 'en-us',
  code: 'en',
  urlPrefix: '/',
  savedLanguage: false,
  selectedRegion: 'US',
  allCountries: [],
  loading: false,
  error: null,
};

/**
 * @typedef {object} Action
 * @prop {string} type
 * @prop {object} payload
 */

/**
 * @type {Function}
 * @param {object} state
 * @param {Action} action
 */

export const localization = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SHOW_LOCALIZATION_SETTINGS:
    case SET_LANGUAGE:
    case SET_PREVIOUS_URL:
    case SET_SAVED_LANGUAGE:
    case GET_COUNTRIES:
    case GET_COUNTRIES_SUCCESS:
    case GET_COUNTRIES_ERROR:
      return {
        ...state,
        ...payload,
      };
    case SET_SELECTED_REGION:
      return {
        ...state,
        selectedRegion: payload.selectedRegion,
      };

    default:
      return state;
  }
};
